var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2917 12.5V15.8333C12.2917 16.7538 11.5455 17.5 10.625 17.5H9.375C8.45452 17.5 7.70833 16.7538 7.70833 15.8333V12.5L2.92345 7.14091C2.65074 6.83548 2.5 6.44035 2.5 6.03088V5C2.5 3.61928 5.85786 2.5 10 2.5C14.1421 2.5 17.5 3.61928 17.5 5V6.03088C17.5 6.44033 17.3493 6.83546 17.0766 7.14088L12.2917 12.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageFilter);
export default ForwardRef;